<template>
  <v-menu bottom left>
    <template v-slot:activator="{ on, attrs }">
      <v-chip class="ma-2" color="success" outlined v-bind="attrs" v-on="on">
        Plataforma
      </v-chip>
    </template>
    <v-card>
      <producto-filtro-plataforma
        type="list"
        @select-plataforma="setPedidosYa"
        :plataformas="plataformas"
      ></producto-filtro-plataforma>
    </v-card>
  </v-menu>

</template>
  
  <script>
import ProductoFiltroPlataforma from "@/components/producto/filtros/producto.filtro.plataforma.vue";

export default {
  components: {
    ProductoFiltroPlataforma,
  },
  data() {
    return {
      selectedPlatform: null,
    };
  },

  watch: {
    "$route.query.py": {
      handler: function (newCategoria) {
        this.selectedPlatform = newCategoria;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    setPedidosYa(value) {
      this.selectedPlatform = value;
      this.updateQuery("py", value);
    },

    updateQuery(key, value) {
      const query = { ...this.$route.query, [key]: value };
      console.log(query);
      this.$router.replace({ query });
    },

    // Remover el filtro de la query
    removeCategoria() {
      this.selectedPlatform = null;
      this.removeQuery("py");
    },

    // Remover el filtro de la query
    removeQuery(key) {
      const query = { ...this.$route.query };
      delete query[key];
      this.$router.replace({ query });
    },
  },
};
</script>
  
  <style scoped>
/* Estilos para los filtros, puedes adaptarlos como necesites */
</style>
  